"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var validatedViewModel_1 = require("./base/validatedViewModel");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        var _this = this;
        _super.call(this, options);
        this.submitSettings = function (form) {
            var els = $(form).find('input:enabled:checked');
            var ids = [];
            var reviews = false;
            els.each(function (i, el) {
                if ($(el).attr('name') == 'reviews') {
                    reviews = true;
                }
                else {
                    ids.push($(el).val());
                }
            });
            _this.processing(true);
            ajaxUtils_1.AjaxUtils.post("discussions/save", {
                CategoryIds: ids,
                Reviews: reviews
            })
                .done(function (result) {
                if (result.isSuccessful) {
                    _this.redirectToPage("all");
                }
                else {
                    alert(result.messages[0]);
                }
            })
                .always(function () {
                _this.processing(false);
            });
        };
        setTimeout(function () {
            _this.initValidation();
        }, 0);
    }
    return ViewModel;
}(validatedViewModel_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=postsSettings.js.map